export function inferClientHints() {
  let resolvedDateTimeFormatOptions = Intl.DateTimeFormat().resolvedOptions();
  return {
    prefersReducedMotion: window.matchMedia("(prefers-reduced-motion: reduce)").matches,
    timeZone: resolvedDateTimeFormatOptions.timeZone ?? "UTC",
    locale: navigator.language,
  };
}
